export enum SignatureOptionEnum {
    DEFAULT = '0',
    NOT_REQUIRED = '2',
    REQUIRED = '1',
    ADULT = '3'
}
